import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";

export default function NotFound() {
    return (
        <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 text-center">
            <img src={BRAND.logo} alt={BRAND.fullName} className="w-16 h-16 object-contain mb-6 opacity-80" />
            <p className="text-xs uppercase tracking-[0.3em] text-inkSoft mb-4 font-body">page not found</p>
            <h1 className="font-heading text-4xl md:text-5xl tracking-tight text-ink mb-4">
                looks like this page drifted away.
            </h1>
            <p className="font-body text-inkSoft max-w-md mb-8">
                the link you followed might be old, mistyped, or moved. Pax is still here though.
            </p>
            <Link
                to="/"
                data-testid="notfound-home"
                className="bg-terracotta text-bone px-6 py-3 rounded-full hover:bg-terracottaHover transition-colors font-body"
            >
                take me home
            </Link>
        </div>
    );
}
